import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  orderId: string
}

const createOrderFullPdf = async (params: Params): Promise<any> => {
  const result = await axios.get(`orders/${params.orderId}/full-pdf`, {
    responseType: 'arraybuffer'
  })
  return result
}

export function useCreateOrderFullPdf() {
  return useMutation(createOrderFullPdf, {
    onSuccess: (data) => {
      const file = new Blob([data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
      toast.success('Download do pdf iniciado!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível obter o pdf!')
    }
  })
}
